import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Switch, Route, Redirect, useLocation } from 'react-router-dom';

// view

import Loading from 'components/Loading';
import {
  ProjectDashboard,
  ExecutiveAlerts,
  BusinessOverview,
  HROverview,
  ApproveExpenses,
} from '../views/Director';
//

import ModuleIndexRedirect from '../components/ModuleIndexRedirect';
import { HomeNavbar } from '../components/Nevbars';
import { MainFooter } from '../components/Footers';
import { MainSidebar } from '../components/Sidebar';
import { NotFound, AccessDenied } from '../components/Error';
import { hasModuleAccess } from '../utils/functions/accessRight';
import * as actions from '../redux/actions';

export function Director() {
  const module = 'DIRECTOR';
  const prefix = '/Director';
  const name = 'finance';
  const dispatch = useDispatch();
  const { pathname } = useLocation();

  const me = useSelector((state) => state.me);

  const [isMobileNavOpen, setMobileNavOpen] = useState(false);
  const handleOnMobileNavOpen = () => {
    setMobileNavOpen(true);
  };
  const handleOnMobileNavClose = () => {
    setMobileNavOpen(false);
  };
  useEffect(() => {
    dispatch(actions.meGet());

    return () => {};
  }, []);
  if (!me.userData) {
    return <Loading />;
  }
  if (!hasModuleAccess(me, module)) {
    return <AccessDenied moduleLabel="ผู้บริหาร" />;
  }
  return (
    <div className="min-h-screen">
      <MainSidebar
        onMobileClose={handleOnMobileNavClose}
        openMobile={isMobileNavOpen}
        me={me}
      />
      <HomeNavbar onMobileNavOpen={handleOnMobileNavOpen} />

      <div className={`relative ${'lg:ml-20'} transition-all duration-200 min-h-screen pt-2 px-8`}>
        <div className="py-4">
          <Switch>
            {' '}
            <Route exact path={`${prefix}/project`}>
              <ProjectDashboard title="ภาพรวมโครงการ" subtitle={name} />
            </Route>
            <Route exact path={`${prefix}/business`}>
              <BusinessOverview title="ธุรกิจ" subtitle={name} />
            </Route>
            <Route exact path={`${prefix}/hr`}>
              <HROverview title="ภาพรวมทรัพยากรบุคคล" subtitle={name} />
            </Route>
            <Route exact path={`${prefix}/approve-expenses`}>
              <ApproveExpenses title="อนุมัติจ่ายเงิน" subtitle={name} />
            </Route>
            <Route exact path={`${prefix}/executive-alerts`}>
              <ExecutiveAlerts title="Executive Alerts" subtitle={name} />
            </Route>
            <Route exact path={prefix}>
              <ModuleIndexRedirect moduleName="DIRECTOR" moduleLabel="ผู้บริหาร" />
            </Route>
            <Route path="*">
              <NotFound />
            </Route>
          </Switch>
        </div>
      </div>
      <div className={`${'lg:ml-20'} transition-all duration-200`}>
        <MainFooter />
      </div>
    </div>
  );
}

export default Director;
